<template>
  <center
    v-if="domain && !forceHidden"
    style="padding-left: 50px;padding-right:50px; padding-top:10px;"
    :style="{ 'margin-top': isMenu ? '15px' : '0'}"
  >
    <v-btn
      block
      outlined
      :color="isMain ? Color : 'white'"
      style="height: 50px;"
      @click="handleGoBack"
    >
      {{backTitle}}
    </v-btn>
  </center>
</template>

<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    name: 'BackButton',
    props: {
      isMain: {
        type: Boolean,
        required: false,
        default: false
      },
      isMenu: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      // domain: null,
      backTitle: ''
    }),
    computed: {
      ...mapState('app',['locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      Color () {
        return this.$store.state.app.Color
      },
      locale () {
        return this.$store.state.app.locale
      },
      isTotem () {
        return this.$route.path.indexOf('/totem') === 0 || utils.isTotem()
      },
      domain () {
        if (this.isTotem) return this.$store.state.app.totemBackDomain
        
        return this.$route.query.back && this.$route.query.back !== undefined ? this.$route.query.back : null
      },
      backPath () {
        return this.$route.query.backPath && this.$route.query.backPath !== undefined ? this.$route.query.backPath : null
      },
      dtouchIsTouchPublic () {
         return this.$store.state.app.dtouchIsTouchPublic
      },
      forceHidden () {
        const domain = utils.getDomain()
        // pedido por WENDY
        return ['amaremarbellabelvue',
          'amaremarbellafoodanddrinks',
          'amaremarbellaverite',
          'amaremarbellavinos',
          'amaremarbellalounge',
          
          'marazulbar','marazulrestaurante', 'clumbabar','clumbarestaurante', 'sonmollattik','sonmollbarlobby','sonmollrestaurante',
          'sentradorplayabarhall','sentradorplayarestaurante','serranopalacepoolbar','serranopalacebarhall','serranopalacerestaurante','sonmollaurabeaty','sentradorplayaspaoasis','marazulsesones'
        ].indexOf(domain) >= 0 ? true : false
      }
    },
    watch: {
      locale (v) {
        this.backTitle = this.$t('common.back', v)
      }
    },
    mounted () {
      this.backTitle = this.$t('common.back', this.locale)
      // api.getItem('enterprises/back-domain', false, this.enterpriseID).then(response => {
      //   this.domain = response.BackDomain && response.BackDomain.length > 0 ? response.BackDomain : null
      // })
    },
    methods: {
      handleGoBack () {
        if (this.isTotem)
          this.handleTotemChangeEnterprise (this.$store.state.app.totemBackDomain)
        else {
          let url = `${window.location.protocol}//${this.domain}.${process.env.VUE_APP_API_URL}`
          url += '#/?'
          if (this.locale !== 'es' || this.dtouchIsTouchPublic) url += '&locale=' + this.locale
          if (this.dtouchIsTouchPublic) url += '&touchPublic=true'
          if (this.backPath) url += `&path=${this.backPath}`
          
          // ini showroom
          const actualUrl = window.location.href
          if (actualUrl.indexOf('?') < 0) url += '?'
          if (actualUrl.indexOf('fm=true') > 0) url += '&fm=true'
          if (actualUrl.indexOf('fl=true') > 0) url += '&fl=true'
          // end showroom
          window.location.href = url
        }
      },
      handleTotemChangeEnterprise (domain) {
        this.$store.state.app.totemBackDomain = null
        this.$store.state.app.totemDomain = domain
      },
    }
  }
</script>
